import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useFiscalYear } from "@/context/FiscalYearContext";
import { PageHeader, Loading, EmptyState } from "@/components/shared";
import { Progress as Bar } from "@/components/ui/progress";

export default function Progress() {
  const { fiscalYear } = useFiscalYear();
  const [rows, setRows] = useState(null);

  useEffect(() => {
    if (!fiscalYear) return;
    api.get(`/progress/summary?fiscal_year=${fiscalYear}`).then(({ data }) => setRows(data));
  }, [fiscalYear]);

  if (!rows) return <Loading />;

  return (
    <div>
      <PageHeader title="進捗管理" subtitle={`${fiscalYear}年度 研修別の受講状況`} />
      {rows.length ? (
        <div className="space-y-4">
          {rows.map((r) => (
            <div key={r.training_id} className="bg-white rounded-xl border border-slate-200 p-5" data-testid={`progress-${r.training_id}`}>
              <div className="flex items-center justify-between mb-3">
                <div className="font-medium text-slate-800">{r.name}</div>
                <div className="text-sm font-semibold text-blue-600">{r.completion_rate}%</div>
              </div>
              <Bar value={r.completion_rate} className="h-2 mb-3" />
              <div className="grid grid-cols-3 sm:grid-cols-6 gap-2 text-center text-xs">
                {[["対象", r.total, "text-slate-700"], ["未開始", r.counts["未開始"], "text-slate-500"],
                  ["受講中", r.in_progress, "text-blue-600"], ["修了", r.completed, "text-green-600"],
                  ["不合格", r.counts["不合格"], "text-rose-600"], ["期限超過", r.overdue, "text-rose-600"]].map(([l, v, c]) => (
                  <div key={l} className="bg-slate-50 rounded-lg py-2">
                    <div className={`text-lg font-bold ${c}`}>{v || 0}</div>
                    <div className="text-slate-400">{l}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      ) : <EmptyState title="研修がありません" />}
    </div>
  );
}
